/* loaded by smart-asset */
export default require("./githubStar~xnsYiqzt.png")